export default "__VITE_ASSET__DMfyIJ$a__"